module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<!-- assets/scripts/templates/factfinder-suggest.lodash.tpl -->\n';

    const regex = new RegExp( query.trim().replaceAll( ' ', '|' ), 'gi' );
    const mark = ( input = '' ) => input.replace( regex, ( match ) => {
        return match.length >= 2 ? `<mark>${match}</mark>` : match;
    } );
    const getCount = ( hitCount = 0 ) => `${hitCount} ${1 === hitCount ? 'Produkt' : 'Produkte'}`;
    const renderItems = ( template, suggestions ) => render( template, { suggestions, mark, query, getCount, productCols } );
;
__p += '\n';
 if ( Object.keys( sideOneSuggests ).length ) { ;
__p += '\n<div class="mdl_search__container mdl_search__container-side1">\n    ';
 if ( 'searchTerm' in sideOneSuggests ) { ;
__p += '\n        ' +
((__t = ( renderItems( 'factfinderSuggestSearchterm', sideOneSuggests.searchTerm ) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n\n    ';
 if ( 'category' in sideOneSuggests ) { ;
__p += '\n        ' +
((__t = ( renderItems( 'factfinderSuggestCategory', sideOneSuggests.category ) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n\n    ';
 if ( 'brand' in sideOneSuggests ) { ;
__p += '\n        ' +
((__t = ( renderItems( 'factfinderSuggestBrand', sideOneSuggests.brand ) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n</div>\n';
 } ;
__p += '\n\n';
 if ( Object.keys( sideTwoSuggests ).length ) { ;
__p += '\n<div class="mdl_search__container mdl_search__container-side2">\n    ';
 if ( 'category' in sideTwoSuggests ) { ;
__p += '\n        ' +
((__t = ( renderItems( 'factfinderSuggestCategory', sideTwoSuggests.category ) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n\n    ';
 if ( 'brand' in sideTwoSuggests ) { ;
__p += '\n        ' +
((__t = ( renderItems( 'factfinderSuggestBrand', sideTwoSuggests.brand ) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n</div>\n';
 } ;
__p += '\n\n';
 if ( Object.keys( mainSuggests ).length && 'productName' in mainSuggests ) { ;
__p += '\n    ' +
((__t = ( renderItems( 'factfinderSuggestProduct', mainSuggests.productName ) )) == null ? '' : __t) +
'\n';
 } ;
__p += '\n';

}
return __p
};
